/* FAR 30/10/2026 (brief §3 A7): caricato da layout/theme.liquid (solo home e carrello, con defer) e non piu dalla sezione generica
   custom-liquid. Con defer lo script parte prima di DOMContentLoaded: aspetta comunque quell evento, come prima, cosi il pulsante
   nasce nello stesso momento e dopo gli altri script della pagina. */
(function () {
  var farDefer = !!(document.currentScript && document.currentScript.defer);
  function ready(callback) {
    if (document.readyState === 'loading' || farDefer) {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  var FAR_VF_LABELS = {
    it: { title: 'Trova i prodotti per la tua moto', subtitle: 'Marca · modello · anno' },
    en: { title: 'Find products for your motorcycle', subtitle: 'Brand · model · year' },
    de: { title: 'Produkte für dein Motorrad finden', subtitle: 'Marke · Modell · Baujahr' },
    es: { title: 'Encuentra productos para tu moto', subtitle: 'Marca · modelo · año' },
    fr: { title: 'Trouvez les produits pour votre moto', subtitle: 'Marque · modèle · année' }
  };

  function labels() {
    var lang = (document.documentElement.getAttribute('lang') || 'it').slice(0, 2).toLowerCase();
    return FAR_VF_LABELS[lang] || FAR_VF_LABELS.it;
  }

  function enhanceVehicleFinder() {
    var section = document.getElementById('shopify-section-ricerca-veicolo-far');
    if (!section) return;

    var panel = section.querySelector('.far-vf');
    if (!panel) return;

    var text = labels();

    Array.prototype.slice.call(section.querySelectorAll('.far-vf-mobile-toggle')).forEach(function (oldToggle) {
      oldToggle.remove();
    });

    section.classList.remove('far-vf-enhanced', 'is-open');

    var panelId = panel.id || 'farVehicleFinderPanel';
    panel.id = panelId;

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'far-vf-mobile-toggle';
    toggle.setAttribute('aria-controls', panelId);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = [
      '<span class="far-vf-mobile-icon" aria-hidden="true">',
      '<svg viewBox="0 0 24 24" focusable="false"><path d="M4 7.5h9.5a3 3 0 1 0 0-2H4v2Zm13-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM4 17.5h4.5a3 3 0 1 0 0-2H4v2Zm8-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM4 12.5h13.5a3 3 0 1 0 0-2H4v2Zm17-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/></svg>',
      '</span>',
      '<span class="far-vf-mobile-copy">',
      '<span class="far-vf-mobile-title"></span>',
      '<span class="far-vf-mobile-subtitle"></span>',
      '</span>',
      '<span class="far-vf-mobile-plus" aria-hidden="true"></span>'
    ].join('');
    toggle.querySelector('.far-vf-mobile-title').textContent = text.title;

    panel.parentNode.insertBefore(toggle, panel);
    section.classList.add('far-vf-enhanced');

    var subtitle = toggle.querySelector('.far-vf-mobile-subtitle');
    var selects = Array.prototype.slice.call(panel.querySelectorAll('select'));

    function setOpen(open) {
      section.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function refreshSubtitle() {
      var chosen = selects
        .map(function (select) {
          return select.value ? select.options[select.selectedIndex].text : '';
        })
        .filter(Boolean);

      subtitle.textContent = chosen.length ? chosen.join(' · ') : text.subtitle;
    }

    toggle.addEventListener('click', function () {
      setOpen(!section.classList.contains('is-open'));
    });

    selects.forEach(function (select) {
      select.addEventListener('change', refreshSubtitle);
    });

    panel.addEventListener('focusin', function () {
      setOpen(true);
    });

    if (window.matchMedia('(min-width: 750px)').matches) {
      setOpen(true);
    }

    refreshSubtitle();

    window.setTimeout(function () {
      var toggles = Array.prototype.slice.call(section.querySelectorAll('.far-vf-mobile-toggle'));
      toggles.slice(1).forEach(function (duplicate) { duplicate.remove(); });
    }, 100);
  }

  ready(enhanceVehicleFinder);
  document.addEventListener('shopify:section:load', enhanceVehicleFinder);
})();
